// @flow
import React, { useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  src: string,
  alt: string,
  className?: string,
  thumbNail?: string,
  isHoveredImagePresent?: boolean,
  keyChange?: number,
  id?: string,
};

export const Image = (props: Props) => {
  const {
    src,
    alt,
    className,
    thumbNail,
    height,
    width,
    objectFit,
    onMouseLeave,
    onMouseEnter,
    isHoveredImagePresent = true,
    keyChange,
    id,
  } = props;
  const { isMobile } = useViewport();
  const [imageLoaded, setImageLoaded] = useState(false);

  const setOnload = () => {
    setImageLoaded(true);
  };

  return (
    <div className={'progressive-img'}>
      <img
        key={keyChange}
        className={`${className} full`}
        onLoad={setOnload}
        style={{
          height: height,
          width: width,
          objectFit: objectFit,
          animation:
            imageLoaded && thumbNail ? 'opacityAnimation 2000ms' : 'none',
        }}
        src={isHoveredImagePresent ? src : ''}
        data-src={src}
        alt={alt}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
        id={id}
      />
      {!isMobile && thumbNail && (
        <img
          className={`${className} thumb`}
          src={thumbNail}
          alt={alt ? alt : 'broken'}
          style={{
            visibility: imageLoaded ? 'hidden' : 'visible',
            position: 'absolute',
            left: '0',
            top: '0',
          }}
        />
      )}
    </div>
  );
};
